import { h, Component } from 'preact';

import style from './style.less';
import pageStyles from '../../pages/pageStyles';

import { Section } from '@cube/layout';
import { Button } from '@cube/blocks';
import callWith from '@os/call-with';

/** Creates banner for promos
 */
export class PromoBanner extends Component {

	buttonClick = (button) => {
		window.location = button.url;
	};

	render({ config }) {
		return (
			<div class={style.promoContainer}>
				<Section containerClass={pageStyles.defaultPageWidth}>
					<div class={style.content}>
						<div class={style.mainText}>
							{config.mainText}
						</div>
						<div class={style.subText}>
							{config.subText}
						</div>
						{ config.buttons &&
							<div class={style.buttons}>
								{
									config.buttons.map(button => (
										<Button onClick={callWith(this.buttonClick, button)} class={style.button}>
											{button.text}
										</Button>
									))
								}
							</div>
						}
						{ config.image &&
							<img class={style.image} src={config.image} />
						}
					</div>
				</Section>
			</div>
		);
	}
}
